import React, {useState} from "react";
import styles from '../../../assets/css/login.module.scss';
import {useFormik} from "formik";
import * as yup from 'yup';
import {Link} from "react-router-dom";
import {useAuthState} from "../../../context/AuthContext";
import tehranLogo from '../../../assets/img/tehran.jpg';
import Card from '@mui/material/Card';
import LinearProgress, {linearProgressClasses} from '@mui/material/LinearProgress';
import {styled} from '@mui/material/styles';

import {Alert, Grid, Snackbar} from "@mui/material";
import {TextField} from "../../../../../components/subComponents/TextField";
import Button1 from "../../../../../components/subComponents/Button1";
import {Utils} from "../../../../../utils/Converts";

const BorderLinearProgress = styled(LinearProgress)(({theme}) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
    },
}));
const Login = props => {
    const [openSnackBar1, setOpenSnackBar1] = useState(false);
    const [message, setMessage] = useState('');
    const [progress, setProgress] = useState(0);
    const [severity,setSeverity]=useState("info");
    let user = useAuthState();
    const loginError = (error) => {
        if (error.response.status === 500)
            console.log("handle");
        // else if(error.response.status=)
        console.log(error.response.status);
        if (error.response && error.response.status) {
            if ((error.response.status / 100) === 5 || error.response.status === 404)
                handleClickSnackBar1('خطایی رخ داد!','error');

            else if (error.response.status === 401) {
                handleClickSnackBar1('پست الکترونیکی یا رمز عبور اشتباه است!','error');

            }
        }
    }

    const handleCloseSnackBar1 = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackBar1(false);
    };
    const handleClickSnackBar1 = (text,severity) => {
        setOpenSnackBar1(true);
        setSeverity(severity);
        setMessage(text);
    };
    const showMessage = async () => {
        handleClickSnackBar1('شما با موفقیت وارد شدید!','info');


        setInterval(() => {
            setProgress((oldProgress) => {
                if (oldProgress === 100) {
                    return 0;
                }
                const diff = 10;
                return oldProgress + diff;
            });
        }, 200);
        await Utils.sleep(2000);
    }

    const validationSchema = yup.object({
        mail: yup
            .string('پست الکترونیکی خود را وارد کنید')
            .email('پست الکترونیکی معتبر وارد کنید')
            .required('وارد کردن پست الکترونیکی اجباری ست.'),
        password: yup
            .string('رمز عبور خود را وارد کنید.')
            // .min(8, 'Password should be of minimum 8 characters length')
            .required('وارد کردن رمز عبور الزامی ست.'),
    });

    const formik = useFormik({
        initialValues: {
            mail: '',
            password: '',
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            user.login(values, loginError, showMessage);
        },
    });

    return <>
        <Grid container className={styles.container}>
            <Grid item md={7} xs={12} className={styles.formContainer}>
                <div>
                    <Card className={styles.card} elevation={3}>
                        {(user.isPending && !openSnackBar1) && <BorderLinearProgress/>}
                        <form onSubmit={formik.handleSubmit} className={styles.form}>
                            <TextField
                                fullWidth
                                id="mail"
                                name="mail"
                                label="پست الکترونیکی"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                error={formik.touched.mail && Boolean(formik.errors.mail)}
                                helperText={formik.touched.mail && formik.errors.mail}
                                variant="outlined"
                                className={styles.textField}
                            />
                            <TextField
                                fullWidth
                                id="password"
                                name="password"
                                label="رمز عبور"
                                type="password"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                error={formik.touched.password && Boolean(formik.errors.password)}
                                helperText={formik.touched.password && formik.errors.password}
                                variant="outlined"
                                className={styles.textField}
                            />
                            <div className={styles.linkContainer}>
                                <Link to={""}>رمز عبور خود را فراموش کرده اید؟ </Link>
                            </div>

                            <Button1 color="primary" variant="contained" fullWidth type="submit"
                                     className={styles.btn}
                                     disabled={user.isPending}>
                                ورود
                            </Button1>


                        </form>
                    </Card>
                </div>
            </Grid>
            <Grid item xs={5} className={styles.bannerContainer}>
                <img src={tehranLogo} alt={""}/>
            </Grid>
        </Grid>
        <Snackbar open={openSnackBar1} autoHideDuration={3000}
                  onClose={handleCloseSnackBar1}
                  className={styles.snackBar}
                  anchorOrigin={{vertical: 'top', horizontal: 'left'}}
                  sx={{width: '40%'}}

        >
            <div className={styles.snackBarContainer}>
                <Alert
                    sx={{width: '100%', height: '100%'}}
                    className={styles.text}
                    severity={severity}
                >
                    {message}
                </Alert>
                <BorderLinearProgress variant="determinate" value={progress}/>

            </div>

        </Snackbar>
    </>;
}

export default Login;
